// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3fFvH","label":"Completed_label__XciYb"};